// auth/forceLogout.ts
export const FORCE_LOGOUT_EVENT = 'app:force-logout';

export const forceLogout = () => {
  try {
    // Mindent kitakarítunk a storage-ból
    localStorage.removeItem('authToken');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('username');
    localStorage.removeItem('selectedRole');
    localStorage.removeItem('buildingId');
    localStorage.removeItem('apartmentId');
    localStorage.removeItem('apartmentName');

    // Szólunk a providereknek (pl. BuildingProvider), hogy tisztítsák a state-et
    window.dispatchEvent(new Event(FORCE_LOGOUT_EVENT));
  } finally {
    // Biztos, hook-mentes átirányítás
    window.location.replace('/');
  }
};
